import React, { useCallback } from 'react';
import { useField } from 'formik';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Slider } from '@/components/ui/slider';

export const RingDurationSetting = React.memo(() => {
  const [field, meta, helpers] = useField<number>('ring_duration');

  const onChange = useCallback((value: number) => helpers.setValue(value), [helpers.setValue]);

  return (
    <Card className="bg-muted rounded-2xl gap-0 p-1 border-0">
      <CardHeader className="px-5 py-3">
        <div>
          <CardTitle className="text-sm font-medium mb-1">Ring Duration</CardTitle>
          <p className="text-sm text-muted-foreground">
            The max ringing duration before the outbound call / transfer call is deemed no answer
          </p>
        </div>
      </CardHeader>
      <CardContent className="bg-card rounded-xl shadow-sm p-5">
        <div className="flex items-center gap-3">
          <div className="flex-1">
            <Slider
              value={[field.value]}
              onValueChange={e => onChange(e[0])}
              max={30}
              min={0}
              step={0.1}
              className="w-full"
            />
          </div>
          <Input
            type="number"
            value={field.value}
            onChange={e => onChange(parseFloat(e.target.value) || 0)}
            step="0.1"
            min="0"
            max="30"
            className="w-16 text-center"
          />
        </div>
        {meta.error && meta.touched && (
          <p className="text-sm text-destructive mt-1">{meta.error}</p>
        )}
      </CardContent>
    </Card>
  );
});
